import { Music } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function MarketingFooter() {
  return (
    <footer className="border-t border-border/40 py-10 px-6">
      <div className="max-w-5xl mx-auto">
        {/* Mobile: stacked center layout / Desktop: horizontal */}
        <div className="flex flex-col items-center gap-6 sm:flex-row sm:justify-between sm:items-center">
          <div className="flex flex-col items-center sm:items-start gap-1">
            <Link to="/" className="flex items-center gap-2">
              <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary">
                <Music className="h-3.5 w-3.5 text-primary-foreground" />
              </div>
              <span className="text-sm font-bold font-display">
                Venue<span className="text-[#c43d10]">Intel</span>
              </span>
            </Link>
            <p className="text-[11px] text-muted-foreground sm:pl-9">
              The operating system for modern venues
            </p>
          </div>

          <nav className="flex flex-col items-center gap-3 sm:flex-row sm:gap-6">
            <Link
              to="/our-story"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Our Story
            </Link>
            <Link
              to="/blog/hidden-cost-disconnected-venue-technology"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Research
            </Link>
            <Link
              to="/privacy"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms
            </Link>
            <a
              href="https://stats.uptimerobot.com/sPB7HvLscf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Status
            </a>
          </nav>

          <p className="text-[11px] text-muted-foreground">
            © {new Date().getFullYear()} VenueIntel
          </p>
        </div>
      </div>
    </footer>
  );
}
